export default {
      id: "action-icon-callback-submitted-usage",
      viewBox: "0 0 30 31",
      url: __webpack_public_path__ + "icons.svg#action-icon-callback-submitted",
      toString: function () {
        return this.url;
      }
    }